import { render, staticRenderFns } from "./ResumoPadrao.vue?vue&type=template&id=24ea0880"
import script from "./ResumoPadrao.vue?vue&type=script&lang=js"
export * from "./ResumoPadrao.vue?vue&type=script&lang=js"
import style0 from "./ResumoPadrao.vue?vue&type=style&index=0&id=24ea0880&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports